import React, { useState, useRef, useCallback } from 'react';


  const MenuItem = ({ item,callsetMenuItems, level = 0 , menuItems,dragSourceRef,handleDragStart,handleDragOver,handleDragLeave,handleDrop,handleDragEnd,onAddSubmenu,onDelete,onEdit,updateItemUrl,updateItemTitle}) => {

	const [isEditing, setIsEditing] = useState(false);
    const [editValue, setEditValue] = useState(item.title);
    const [showAdvanced, setShowAdvanced] = useState(false);

	// Función para manejar la subida de imágenes
	const handleImageUpload = (e, itemId) => {
	  const file = e.target.files[0];
	  if (!file) return;

	  // Validar que sea una imagen
	  if (!file.type.startsWith('image/')) {
	    alert('Por favor selecciona un archivo de imagen válido');
	    return;
	  }

	  // Validar tamaño (opcional - 5MB máximo)
	  if (file.size > 5 * 1024 * 1024) {
	    alert('La imagen no debe superar los 5MB');
	    return;
	  }

	  // Crear preview URL
	  const previewUrl = URL.createObjectURL(file);


	  // Actualizar el item con la imagen
	  const updateItems = (items) => {
	    return items.map(item => {
	      if (item.id === itemId) {
	        return {
	          ...item,
	          imageFile: file,
	          imagePreview: previewUrl,
	          imageName: file.name
	        };
	      }
	      if (item.children && item.children.length > 0) {
	        return { ...item, children: updateItems(item.children) };
	      }
	      return item;
	    });
	  };

	  callsetMenuItems(updateItems(menuItems));
	  //showNotification('Imagen añadida al elemento');
	};

	const removeImage = (itemId) => {
	  const updateItems = (items) => {
	    return items.map(item => {
	      if (item.id === itemId) {
	        // Limpiar la URL del objeto para evitar memory leaks
	        if (item.imagePreview) {
	          URL.revokeObjectURL(item.imagePreview);
	        }
	        const { imageFile, imagePreview, imageName, ...rest } = item;
	        return rest;
	      }
	      if (item.children && item.children.length > 0) {
	        return { ...item, children: updateItems(item.children) };
	      }
	      return item;
	    });
	  };

	  callsetMenuItems(updateItems(menuItems));
	  //showNotification('Imagen eliminada');
	};    

	const getTypeLabel = (type) => {
	    const labels = {
	      'page': 'PÁGINA',
	      'category': 'CATEGORÍA',
	      'custom': 'PERSONALIZADO'
	    };
	    return labels[type] || type?.toUpperCase() || 'ITEM';
	};

	const getIconComponent = (iconName) => {
	    switch(iconName) {
	      case 'file': return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-folder" aria-hidden="true"><path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"></path></svg>;
	      case 'folder': return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-menu" aria-hidden="true"><path d="M4 5h16"></path><path d="M4 12h16"></path><path d="M4 19h16"></path></svg>;
	      case 'link': return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>;
	      default: return <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-grip-vertical" aria-hidden="true"><circle cx="9" cy="12" r="1"></circle><circle cx="9" cy="5" r="1"></circle><circle cx="9" cy="19" r="1"></circle><circle cx="15" cy="12" r="1"></circle><circle cx="15" cy="5" r="1"></circle><circle cx="15" cy="19" r="1"></circle></svg>;
	    }
	};

    const handleDoubleClick = () => {
      setIsEditing(true);
      setEditValue(item.title);
    };
    
    const handleEditSave = () => {
      if (editValue.trim()) {
        updateItemTitle(item.id, editValue.trim());
      }
      setIsEditing(false);
    };
    
    const handleKeyPress = (e) => {
      if (e.key === 'Enter') {
        handleEditSave();
      }
    };

  return (
      <div 
      className="menu-item" 
      data-id={item.id} 
      data-type={item.type}
      draggable="true"
      onDragStart={(e) => handleDragStart(e, item.id)}
      onDragOver={(e) => handleDragOver(e, item.id)}
      onDragLeave={handleDragLeave}
      onDrop={(e) => handleDrop(e, item.id)}
      onDragEnd={handleDragEnd}
      >
        <div className="menu-item-header">
          <span className="menu-item-drag">
            
          </span>
          
          {item.children && item.children.length > 0 && (
            <span className="menu-toggle">
              {item.expanded ? <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg> : <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-right" aria-hidden="true"><path d="m9 18 6-6-6-6"></path></svg> }
            </span>
          )}
          
          <span className="menu-item-icon">
            {getIconComponent(item.icon)}
          </span>
          
          {isEditing ? (
            <input
              type="text"
              className="menu-item-title-input"
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              onBlur={handleEditSave}
              onKeyPress={handleKeyPress}
              autoFocus
            />
          ) : (
            <span 
              className="menu-item-title"
              onDoubleClick={handleDoubleClick}
            >
              {item.title}
            </span>
          )}
          
          <span className="menu-item-type">
            {getTypeLabel(item.type)}
          </span>
          
          <div className="menu-item-actions">
            <button 
              className="action-btn"
              onClick={() => setShowAdvanced(!showAdvanced)}
              title="Configuración"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-settings" aria-hidden="true"><path d="M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915"></path><circle cx="12" cy="12" r="3"></circle></svg>
            </button>
            <button 
              className="action-btn"
              onClick={() => onAddSubmenu(item.id)}
              title="Añadir submenú"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus" aria-hidden="true"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>
              
            </button>
            <button 
              className="action-btn delete"
              onClick={() => onDelete(item.id)}
              title="Eliminar"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2 lucide-trash-2" aria-hidden="true"><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"></path><path d="M3 6h18"></path><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
              
            </button>
          </div>
        </div>
        
        {showAdvanced && (
          <div className="menu-item-advanced">
            <div className="advanced-field">
              <label>URL</label>
              <input
                type="text"
                className="item-url"
                defaultValue={item.url || '#'}
                onChange={(e) => updateItemUrl(item.id, e.target.value)}
                placeholder="URL"
              />
            </div>
            <div className="advanced-field">
              <label>Clase CSS</label>
              <input
                type="text"
                defaultValue={item.class || ''}
                placeholder="clase-css"
              />
            </div>

            {/* NUEVO CAMPO: Input file para imágenes */}
            <div className="advanced-field image-field">
              <label>Imagen del menú</label>
              <div className="image-input-container">
                <input
                  type="file"
                  accept="image/*"
                  className="item-image-input"
                  id={`image-${item.id}`}
                  onChange={(e) => handleImageUpload(e, item.id)}
                  style={{ display: 'none' }}
                />
                
                <div className="image-preview-container">
                  {item.imagePreview ? (
                    <div className="image-preview">
                      <img 
                        src={item.imagePreview} 
                        alt="Preview" 
                        className="preview-thumb"
                      />
                      <button 
                        className="remove-image-btn"
                        onClick={() => removeImage(item.id)}
                        type="button"
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    </div>
                  ) : (
                    <button 
                      className="upload-image-btn"
                      onClick={() => document.getElementById(`image-${item.id}`).click()}
                      type="button"
                    >
                      <i className="fas fa-upload"></i>
                      <span>Seleccionar imagen</span>
                    </button>
                  )}
                </div>
                
                {item.imageFile && (
                  <div className="image-info">
                    <small>{item.imageFile.name}</small>
                  </div>
                )}
              </div>
            </div>

          </div>
        )}
        
        {item.children && item.children.length > 0 && (
          <div className="submenu-container">
            {item.children.map(child => (

              	<MenuItem 
			          callsetMenuItems={callsetMenuItems} 
			          key={child.id} 
			          item={child} 
			          menuItems={menuItems}
			          onDelete = {onDelete}
			          onEdit = {onEdit}
			          updateItemTitle = {updateItemTitle}
			          updateItemUrl = {updateItemUrl}
		        />

            ))}
          </div>
        )}
      </div>
    );
  };

const MenuLateralRight = ({showListAvailable,itemCount,notification,saveMenu,menuItems,callsetMenuItems,updateItemUrl, dragSourceRef,handleDragStart,handleDragOver,handleDragLeave,handleDrop,handleDragEnd,onAddSubmenu,onDelete,onEdit,updateItemTitle}) => {

return (
<div className="wp-main-panel">
            <div className="wp-panel-header">
              <div className="panel-title">
                <span>Estructura del menú</span>
              </div>
              <div className="panel-info">
                {itemCount} elemento{itemCount !== 1 ? 's' : ''}
              </div>
            </div>
            
            <div className="menu-container">
		        {menuItems.map(item => (
		          <MenuItem 
			          callsetMenuItems={callsetMenuItems} 
			          key={item.id} 
			          item={item} 
			          menuItems={menuItems}
			          dragSourceRef ={dragSourceRef}
			          handleDragStart ={handleDragStart}
			          handleDragOver = {handleDragOver}
			          handleDragLeave = {handleDragLeave}
			          handleDrop = {handleDrop}
			          handleDragEnd = {handleDragEnd}            
			          onAddSubmenu = {onAddSubmenu}
			          onDelete = {onDelete}
			          onEdit = {onEdit}
			          updateItemTitle = {updateItemTitle}
			          updateItemUrl = {updateItemUrl}
		           />
		        ))}
              
            </div>
            
            {/* Barra de guardado */}
            <div className="wp-save-bar">
              <div className="save-indicator">
                {notification ? (
                  <span className="saved">✓ {notification}</span>
                ) : (
                  <span>Cambios guardados automáticamente</span>
                )}
              </div>
              <div className="save-actions">
                <button className="wp-button" 
                onClick={() => saveMenu()}>
                   Guardar menú
                </button>
              </div>
            </div>
</div>
)}

export default MenuLateralRight;